import { NgModule } from '@angular/core';
import { VideoTutorialsComponent } from './video-tutorials.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [VideoTutorialsComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ComponentsModule,
    RouterModule.forChild([
      {
        path: '',
        component: VideoTutorialsComponent,
      },
    ]),
  ],
})
export class VideoTutorialsModule {}
